export default "__VITE_ASSET__D2noj$1a__"